import { UserData } from "../types/user/types";

export const isHighBloodPressure = (user: UserData) => {

  const NORMAL_RANGES = {
    systolic: { min: 90, max: 120 },
    diastolic: { min: 60, max: 80 },
    heartRate: { min: 60, max: 100 },
  };

  let hasExceed = false;
  let hasBelow = false;

  if (user.bloodPressure && user.bloodPressure.length > 0) {

    // Grab the latest blood pressure test
    const latestBloodPressure = user.bloodPressure.reduce((latest, current) => {
      const latestTime = new Date(latest.testTimestamptz).getTime();
      const currentTime = new Date(current.testTimestamptz).getTime();
      return currentTime > latestTime ? current : latest;
    }, user.bloodPressure[0]);

    // Check latest blood pressure reading
    const { systolic, diastolic, heartRate } = latestBloodPressure;

    if (systolic > NORMAL_RANGES.systolic.max || diastolic > NORMAL_RANGES.diastolic.max) {
      hasExceed = true;
    } else if (systolic < NORMAL_RANGES.systolic.min || diastolic < NORMAL_RANGES.diastolic.min) {
      hasBelow = true;
    }

    // Check heart rate
    if (heartRate > NORMAL_RANGES.heartRate.max) {
      hasExceed = true;
    } else if (heartRate < NORMAL_RANGES.heartRate.min) {
      hasBelow = true;
    }

    return (hasExceed || hasBelow)
  }

  return false
}
